module.exports = __webpack_public_path__ + "img/campaignpilot-campaign-golf.7712c1c8.png";